<template>
    <div class="dropdown">
        <!-- Note: BS 5 uses data-bs-toggle, BS4 uses just data-bs-toggle -->
        <button class="btn btn-sm btn-light dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
            Themes
        </button>
        <ul class="dropdown-menu">
            <li><h6 class="dropdown-header">Available Themes</h6></li>
            <li><a v-for="theme in model.themes" class="dropdown-item" :class="isThemeSelected(theme) ? 'active' : ''"
                   href="javascript:void(0)" @click.stop="onThemeSelected(theme)">{{theme.name}}</a></li>
            <li><hr class="dropdown-divider"></li>
            <li><a class="dropdown-item" href="javascript:void(0)" @click.stop="onClearClick">Clear Theme</a></li>
        </ul>
    </div>
</template>

<script>
import AppService from "../../services/AppService";

export default {
    name: 'ThemeDropdown',
    props: ['currentApp'],
    data () {
        return {
            model: webase.model,
            selectedThemeId: null,
            service: new AppService(),
        }
    },
    mounted () {
        this.selectedThemeId = this.currentApp.theme_id
    },
    methods: {
        isThemeSelected(theme) {
            return this.selectedThemeId === theme.id
        },
        onThemeSelected(theme) {
            this.selectedThemeId = theme.id
            this.currentApp.theme_id = this.selectedThemeId
            webase.utils.ui.injectCss(`themes/${theme.id}`)
            this.updateAppTheme()
        },
        onClearClick() {
            webase.utils.ui.removeThemeLink()
            this.selectedThemeId = null
            this.updateAppTheme()
        },
        updateAppTheme() {
            let request = {
                app: {
                    theme_id: this.selectedThemeId
                }
            }

            this.service.update(this.currentApp.id, request)
        }
    }
}
</script>

<style>

</style>
